import React from "react";
import Layout from "../../components/layout/Layout/Layout";
import Header from "../../components/layout/Header/Header";
import { About } from "../../components/global/About/About";
import { getAboutInfo } from "../../lib/aboutRequest";
import { GetServerSideProps } from "next";

export const getServerSideProps: GetServerSideProps = async () => {
  try {
    const { data } = await getAboutInfo();

    return { props: { data } };
  } catch (error) {
    return { props: { error: "Failed to fetch data" } };
  }
};

export default function AboutPage({ data, error }) {
  return (
    <Layout>
      <Header></Header>
      <About data={data} error={error} />
    </Layout>
  );
}
